import React, { Fragment, useState, useEffect } from "react";
import io from "socket.io-client";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import { getGifs, getGifsSearch } from "../../actions/gif";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import DiscussionChat from "../layout/Innovators/DiscussionChat";
import DiscussionDualVideos from "../layout/Innovators/DiscussionDualVideos";
import DiscussionQuadVideos from "../layout/Innovators/DiscussionQuadVideos";
import DiscussionGroupVideos from "../layout/Innovators/DiscussionGroupVideos";
import TwoParticipants from "../layout/Innovators/TwoParticipants";
import FourParticipants from "../layout/Innovators/FourParticipants";
import EightParticipants from "../layout/Innovators/EightParticipants";
import DiscussionOfDay from "../layout/Innovators/DiscussionOfDay";
import DiscussionPoints from "../layout/Innovators/DiscussionPoints";
import StreamSecondaryLogo from "../layout/IME/StreamSecondaryLogo";

let socket;

const IMEDiscussion = ({
  match,
  auth: { user },
  getGifs,
  gif: { gifs, loading },
  isAuthenticated,
}) => {
  const ENDPOINT = "localhost:5000";

  const [participant, setParticpant] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [showGIFs, setshowGIFs] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [text, setText] = useState("");
  const [foundGif, setGif] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [room, setRoom] = useState(match.params.industryname);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_green.png");
  const [showChat, setShowChat] = useState(true);
  const [id, setid] = useState("");

  useEffect(() => {
    getGifs();
    setRoom(match.params.industryname);
  }, [match.params.industryname, room]);

  useEffect(() => {
    socket = io(ENDPOINT);

    if (user) {
      setRoom(match.params.industryname);

      socket.on("connection", (message) => {});

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        firstname: user.firstname,
        lastname: user.lastname,
        avatar: user.avatar,
        room: room,
      });

      return () => {
        if (socket) {
          socket.emit("leave");

          socket.on("roomUsers", (users) => {
            // setViewerCount([...users.users]);
          });

          socket.disconnect();

          socket.off();
        }
      };
    }
  }, [ENDPOINT, setRoom]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
  }, [messages]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (message || foundGif !== "") {
      socket.emit(
        "chatMessage",
        message,
        foundGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setMessage("");
      setGif("");
      setshowGIFs(false);
    }
  };

  let userIndex = participants
    .map((x) => {
      return x.id;
    })
    .indexOf(id);

  const sendParticipant = () => {
    socket.emit("sendParticipant", {
      avatar: user.avatar,
      firstname: user.firstname,
      lastname: user.lastname,
      // id: user._id,
    });
  };

  const removeParticipant = () => {
    participants.splice(userIndex, 1);
    socket.emit("removeParticipant", () => {
      setParticipants([...participants, participant]);
    });
  };

  useEffect(() => {
    socket.on("participants", (participant) => {
      setParticipants([...participants, participant]);
    });
  }, [participants]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {isAuthenticated && <LoggedInNav />}
      {!isAuthenticated && <LoggedOutNav />}
      <div className={showChat ? "discuss-flex-only" : "discuss-flex"}>
        <div className="main-stream-content">
          <div className="video-chat">
            {/* <DiscussionDualVideos showChat={showChat} /> */}
            {/* <DiscussionQuadVideos showChat={showChat} /> */}
            <DiscussionGroupVideos showChat={showChat} />
            {!showChat && (
              <div className="showchaticon" onClick={() => setShowChat(true)}>
                <i className="far fa-comment fa-2x green"></i>
              </div>
            )}
          </div>
          {isAuthenticated && user.role === "innovator" && (
            <div className="discussion-join">
              {!participant && user && user.role === "innovator" ? (
                <div class="action-items-stream-alt">
                  <div
                    onClick={() => {
                      sendParticipant();
                      setParticpant(true);
                    }}
                    class="action-button green"
                  >
                    <i class="fas fa-user-plus action-icon fa-lg"></i>
                  </div>
                  <p class="action-text">Join Discussion</p>
                </div>
              ) : (
                <div className="queue-position green bold">
                  Position in queue: {userIndex + 1}
                  <div
                    onClick={() => {
                      removeParticipant();
                      setParticpant(false);
                    }}
                    class="action-items-stream-alt"
                  >
                    <div class="action-button green">
                      <i class="fas fa-user-minus action-icon fa-lg"></i>
                    </div>
                    <p class="action-text">
                      Discussion Joined! Click to remove as participant.
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="discussion-topic-hero-alt">
            <DiscussionOfDay />
            <DiscussionPoints />
          </div>
          <div className="discussion-join">
            <StreamSecondaryLogo />
          </div>
          <div className="stream-section-container">
            <div className="padding-container">
              <div className="title-container-info">
                <div className="border-alt green">
                  <p className="online-title-alt green">Up Next</p>
                </div>
              </div>
              <div className="participants">
                <TwoParticipants
                  key={participant.id}
                  participant={participant}
                  participants={participants}
                />
              </div>
            </div>
          </div>
          {/* <div className="stream-section-container">
            <div className="padding-container">
              <div className="title-container-info">
                <div className="border-alt green">
                  <p className="online-title-alt green">Up Next</p>
                </div>
              </div>
              <FourParticipants />
            </div>
          </div>
          <div className="stream-section-container">
            <div className="padding-container">
              <div className="title-container-info">
                <div className="border-alt green">
                  <p className="online-title-alt green">Up Next</p>
                </div>
              </div>
              <EightParticipants />
            </div>
          </div> */}
          <div className="margin-top"></div>
        </div>
        {showChat && (
          <DiscussionChat
            messages={messages}
            message={message}
            setMessage={setMessage}
            gifs={gifs}
            setGif={setGif}
            foundGif={foundGif}
            showGIFs={showGIFs}
            setshowGIFs={setshowGIFs}
            gifSearch={gifSearch}
            setGifSearch={setGifSearch}
            sendMessage={sendMessage}
            text={text}
            setText={setText}
            setShowChat={setShowChat}
          />
        )}
      </div>
    </Fragment>
  );
};

IMEDiscussion.propTypes = {
  auth: PropTypes.object.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gif: state.gif,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getGifs,
  getGifsSearch,
})(IMEDiscussion);
